<svg
  width="17"
  height="17"
  viewBox="0 0 17 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    d="M8.37283 3.47144C4.467 3.47144 1.26172 6.37668 1.26172 9.94784V12.9956C1.26172 13.6258 1.82244 14.1385 2.51172 14.1385H2.92839V10.3288H2.51172C2.36494 10.3288 2.22602 10.3563 2.09505 10.399V9.94784C2.09505 6.7967 4.92639 4.23337 8.37283 4.23337C11.8193 4.23337 14.6506 6.7967 14.6506 9.94784V10.399C14.5196 10.3563 14.3807 10.3288 14.2339 10.3288H13.8173V14.1385H14.2339C14.9232 14.1385 15.4839 13.6258 15.4839 12.9956V9.94784C15.4839 6.37668 12.2787 3.47144 8.37283 3.47144Z"
  />
  <path
    d="M5.01172 9.56689H4.59505C4.1348 9.56689 3.76172 9.90801 3.76172 10.3288V14.1385C3.76172 14.5593 4.1348 14.9004 4.59505 14.9004H5.01172C5.24183 14.9004 5.42839 14.7298 5.42839 14.5194V9.94786C5.42839 9.73747 5.24183 9.56689 5.01172 9.56689Z"
  />
  <path
    d="M12.1507 9.56689H11.734C11.5039 9.56689 11.3174 9.73747 11.3174 9.94786V14.5194C11.3174 14.7298 11.5039 14.9004 11.734 14.9004H12.1507C12.611 14.9004 12.984 14.5593 12.984 14.1385V10.3288C12.984 9.90801 12.611 9.56689 12.1507 9.56689Z"
  />

  <rect
    *ngIf="disabled"
    id="Rectangle 343"
    x="1.80762"
    y="3.36292"
    width="1.75994"
    height="19.3167"
    rx="0.87997"
    transform="rotate(-45 1.80762 3.36292)"
    fill="white"
  />
</svg>
